import MicroModal from 'micromodal';

export namespace NLConsentCollection {
	
	let setupNLConsentModal = () => {
		let links = document.querySelectorAll('.js-lead-consent');

		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				
					MicroModal.show('modal-lead-consent', {
						onShow: function () {
							var butCheck = document.querySelector('.mat-focus-indicator');
							document.querySelector('.mat-focus-indicator').addEventListener('click', myfunction);
							var flagClicked = false;
							function myfunction() {
								flagClicked = true;
							}
							//let leadConsentBtn = document.getElementById('ModalLeadConsentSubmit');
							//if (leadConsentBtn) {
							//	leadConsentBtn.blur();
							//}
						},
						onClose: function () {							
							let nlBtn = document.getElementById('nlSubscribeBtn');
							if (nlBtn) {
								nlBtn.blur();
							}
						}
					});
				
				//e.preventDefault();
				// if the consent is saved successfully then enable the Submit button on the Lead form.

				//var checkBox = <HTMLInputElement> document.getElementById('nlSubscribe');
				//var submitBtn = <HTMLInputElement> document.getElementById('nlSubscribeBtn');
				//if (checkBox.checked == true) {
				//	submitBtn.disabled = false;
				//} 
			});
		});
	}

	export const init = () => {
		setupNLConsentModal();
	}
}


document.addEventListener('DOMContentLoaded', NLConsentCollection.init);
